import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import { text } from './helpers';
export default function configureHomeTitle() {
  extend(app, 'updateTitle', function () {
    const route = m.route.get();
    if (!route) return;
    const basePath = (this.forum.attribute('basePath') || '').replace(/\/+$/, '');
    const path = route.split(/[?#]/)[0].replace(/\/+$/, '');
    if (path !== basePath && path !== basePath + '/home') return;
    const count = this.titleCount ? `(${this.titleCount}) ` : '';
    document.title = count + text('home.browser_title', {
      brand: this.forum.attribute('title')
    });
  });
}